import { useEffect, useState } from "react";
import homeScreen from "../../assets/images/getIt_preview/home_screen.png";
import topicScreen from "../../assets/images/getIt_preview/topic_screen.png";
import scaleScreen from "../../assets/images/getIt_preview/scale_screen.png";
import appIcon from "../../assets/images/getIt_preview/1024.png";
import "./PreviewGallerySection.css";

const previewImages = [
  { src: homeScreen, alt: "Home screen preview" },
  { src: topicScreen, alt: "Topic screen preview" },
  { src: scaleScreen, alt: "Scale screen preview" },
];

function PreviewGallerySection() {
  const [visiblePreviewCount, setVisiblePreviewCount] = useState(3);

  useEffect(() => {
    const updateVisiblePreviewCount = () => {
      const viewportWidth = window.innerWidth;

      if (viewportWidth <= 640) {
        setVisiblePreviewCount(1);
        return;
      }

      if (viewportWidth <= 960) {
        setVisiblePreviewCount(2);
        return;
      }

      setVisiblePreviewCount(3);
    };

    updateVisiblePreviewCount();
    window.addEventListener("resize", updateVisiblePreviewCount);

    return () => {
      window.removeEventListener("resize", updateVisiblePreviewCount);
    };
  }, []);

  return (
    <section className="preview-gallery">
      <div className="preview-gallery__stack">
        <div className="preview-gallery__row-overlay">
          <div className="preview-gallery__column">
            <div className="preview-gallery__row-overlay-row">
              <img
                src={appIcon}
                alt="GetIt App Icon"
                className="preview-gallery__app-icon"
              />
              <p className="preview-gallery__row-label">
                Get It! Download <br />
                the Partygame
              </p>
            </div>
            <a
              className="preview-gallery__download-button"
              href="https://apps.apple.com/us/app/get-it-the-partygame/id6756636249"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Now
            </a>
          </div>
        </div>

        <div className="preview-gallery__row">
          {previewImages.slice(0, visiblePreviewCount).map((image) => (
            <div key={image.alt} className="preview-gallery__card">
              <img
                src={image.src}
                alt={image.alt}
                className="preview-gallery__image"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PreviewGallerySection;
